import { render, staticRenderFns } from "./SplitsPaymentsMethodCD.vue?vue&type=template&id=1051d832&scoped=true&"
import script from "./SplitsPaymentsMethodCD.vue?vue&type=script&lang=js&"
export * from "./SplitsPaymentsMethodCD.vue?vue&type=script&lang=js&"
import style0 from "./SplitsPaymentsMethodCD.vue?vue&type=style&index=0&id=1051d832&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1051d832",
  null
  
)

export default component.exports